export function footerGradient() {
    gsap.registerPlugin(ScrollTrigger);

    const gradient = document.querySelector(".footer__gradient");
    if (gradient) {
        gsap.to(gradient, {
            opacity: .25,
            duration: 1.2,
            ease: "power4.out",
            scrollTrigger: {
                trigger: ".footer",
                start: "top 60%",
                toggleActions: "play none none none",
            }
        });
    }
}
